import * as React from 'react'

import { IChild } from 'main/gql/child'
import BaseChildrenSelector from './BaseChildrenSelector'
import { IChildEditState } from './ChildSection'

interface IProps {
  children: IChild[]
  selectedChildren: IChild[]
  editStates: IChildEditState[]
  validationHint?: string
  onAddChild?: (child: IChild) => void
  onUpdateChild?: (child: IChild) => void
  onChangeSelectedChildren: (child: IChild[]) => void
  onChangeEditStates: (editStates: IChildEditState[]) => void
}

export default function ChildrenSelector(props: IProps) {
  return <BaseChildrenSelector {...props} multiple />
}
